import Vue from 'vue';
import Vuex from 'vuex';

import staticDataModule from './modules/staticData/staticData';
import contentDataModule from './modules/contentData/contentData';
import featureSetModule from './modules/featureSet/featureSet';
import gallery from './modules/gallery/gallery';
import title from './modules/title';

let cName;
let headerText = '';
let readMoreText = '';
let logoText = '';
const CID = Number(process.env.VUE_APP_CID);
switch (CID) {
case 1:
	cName = 'Stanislav Dimitrov';
	break;
case 2:
	cName = 'Eszter Havasi';
	break;
case 3:
	cName = 'Mateus Dela Fonte';
	break;
case 4:
	cName = 'Latinos Clássicos';
	break;
case 5:
	cName = 'Miles Solutions';
	break;
case 6:
	cName = 'NZKM';
	headerText = 'NOVE ZVEZDE KLASIČNE MUZIKE';
	break;
case 7:
	cName = 'OPUS e.V';
	logoText = 'OPUS';
	break;
case 8:
	cName = 'Antonina Krymova';
	break;
case 9:
	cName = 'Andrej Jussow';
	break;
case 10:
	cName = 'Dimcho Velichkov';
	break;
case 12:
	cName = 'Beogradjani';
	break;
case 13:
	cName = 'AGS';
	readMoreText = 'weiter lesen...';
	break;
case 14:
	cName = 'Pobednik';
	break;
default:
	cName = 'Website';
}

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		staticData: staticDataModule,
		contentData: contentDataModule,
		featureSet: featureSetModule,
		gallery,
		title,
	},
	state: {
		CID,
		cName,
		headerText,
		readMoreText,
		logoText,
	},
	mutations: {

	},
	actions: {

	},
});
